import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createaccountgroup, viewaccountgroup, listactiveaccounttypes } from "../../../../services/admin";
import { toast } from "react-toastify";
import Select from "react-select";

export default function AddAccountGroup() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [accountTypes, setAccountTypes] = useState([]);
    const [formData, setFormData] = useState({
        id: 0,
        account_type_id: "",
        group_name: "",
        group_code: "",
        description: "",
        display_order: 0,
        is_active: true,
    });

    useEffect(() => {
        // Fetch account types
        listactiveaccounttypes().then((res) => {
            if (res.status === true) {
                const options = res.data.map((type) => ({
                    value: type.id,
                    label: type.type_name,
                }));
                setAccountTypes(options);
            }
        });

        // If editing, fetch group data
        if (id) {
            viewaccountgroup(id).then((res) => {
                if (res.status === true) {
                    const data = res.data.details;
                    setFormData({
                        id: data.id,
                        account_type_id: data.account_type_id,
                        group_name: data.group_name,
                        group_code: data.group_code,
                        description: data.description || "",
                        display_order: data.display_order,
                        is_active: data.is_active,
                    });
                }
            });
        }
    }, [id]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleAccountTypeChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            account_type_id: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.account_type_id) {
            toast.error("Please select account type");
            return;
        }
        if (!formData.group_name) {
            toast.error("Please enter group name");
            return;
        }
        if (!formData.group_code) {
            toast.error("Please enter group code");
            return;
        }

        createaccountgroup(formData).then((res) => {
            if (res.status === true) {
                toast.success(res.message);
                navigate("/master/accountgroups");
            } else {
                toast.error(res.message);
            }
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    {id ? "Edit Account Group" : "Add Account Group"}
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Master</a>
                    </li>
                    <li className="breadcrumb-item">
                        <a onClick={() => navigate("/master/accountgroups")}>Account Groups</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {id ? "Edit" : "Add"}
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-6">
                                            <h4 className="card-title">
                                                {id ? "Edit Account Group" : "Add New Account Group"}
                                            </h4>
                                        </div>
                                        <div className="col-6 text-end">
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => navigate("/master/accountgroups")}
                                            >
                                                <i className="fa fa-arrow-left"></i> Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Account Type <span className="text-danger">*</span>
                                                </label>
                                                <Select
                                                    options={accountTypes}
                                                    value={accountTypes.find(
                                                        (opt) => opt.value === formData.account_type_id
                                                    )}
                                                    onChange={handleAccountTypeChange}
                                                    placeholder="Select Account Type"
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Group Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="group_name"
                                                    value={formData.group_name}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter group name (e.g., Current Assets)"
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Group Code <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="group_code"
                                                    value={formData.group_code}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter group code (e.g., AST-CUR)"
                                                    disabled={id ? true : false}
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Display Order</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="display_order"
                                                    value={formData.display_order}
                                                    onChange={handleInputChange}
                                                    min="0"
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Description</label>
                                                <textarea
                                                    className="form-control"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleInputChange}
                                                    rows="3"
                                                    placeholder="Enter description"
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        name="is_active"
                                                        checked={formData.is_active}
                                                        onChange={handleInputChange}
                                                        id="is_active"
                                                    />
                                                    <label className="form-check-label" htmlFor="is_active">
                                                        Active
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mt-3">
                                            <div className="col-md-12 text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-2"
                                                    onClick={() => navigate("/master/accountgroups")}
                                                >
                                                    Cancel
                                                </button>
                                                <button type="submit" className="btn btn-primary">
                                                    <i className="fa fa-save"></i>{" "}
                                                    {id ? "Update" : "Create"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
